// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AboutInfoCards Component Styles */
.about-info-cards {
  padding: 80px 0;
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f4fd 100%);
}

.about-info-cards__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Grid Layout */
.about-info-cards__grid--grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
}

/* Row Layout */
.about-info-cards__grid--row {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Masonry Layout */
.about-info-cards__grid--masonry {
  columns: 2;
  column-gap: 2rem;
}

.about-info-cards__grid--masonry .about-info-cards__card {
  break-inside: avoid;
  margin-bottom: 2rem;
}

.about-info-cards__card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 8px 32px rgba(74, 144, 226, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(74, 144, 226, 0.1);
  position: relative;
  overflow: hidden;
}

.about-info-cards__card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4A90E2, #87ceeb, #4A90E2);
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

.about-info-cards__card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(74, 144, 226, 0.15);
  border-color: rgba(74, 144, 226, 0.2);
}

.about-info-cards__card:hover::before {
  transform: translateX(0);
}

.about-info-cards__card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.about-info-cards__card-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

.about-info-cards__card-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #4A90E2;
  line-height: 1.3;
  flex: 1;
}

.about-info-cards__card-content {
  line-height: 1.7;
}

.about-info-cards__card-text {
  font-size: 1.05rem;
  color: #555;
  text-align: justify;
  margin: 0;
}

/* Animation for cards */
.about-info-cards__card {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeInUp 0.6s ease forwards;
}

.about-info-cards__card:nth-child(1) { animation-delay: 0.1s; }
.about-info-cards__card:nth-child(2) { animation-delay: 0.2s; }
.about-info-cards__card:nth-child(3) { animation-delay: 0.3s; }
.about-info-cards__card:nth-child(4) { animation-delay: 0.4s; }
.about-info-cards__card:nth-child(5) { animation-delay: 0.5s; }
.about-info-cards__card:nth-child(6) { animation-delay: 0.6s; }

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Special styling for third card (longer content) */
.about-info-cards__card:nth-child(3) {
  grid-column: span 2;
}

.about-info-cards__grid--grid .about-info-cards__card:nth-child(3) {
  grid-column: 1 / -1;
}

.about-info-cards__card:nth-child(3) .about-info-cards__card-header {
  justify-content: center;
  text-align: center;
  flex-direction: column;
  gap: 1rem;
}

.about-info-cards__card:nth-child(3) .about-info-cards__card-text {
  text-align: center;
  font-size: 1.1rem;
  max-width: 800px;
  margin: 0 auto;
}

/* Responsive Design */
@media (max-width: 768px) {
  .about-info-cards {
    padding: 60px 0;
  }
  
  .about-info-cards__container {
    padding: 0 1.5rem;
  }
  
  .about-info-cards__grid--grid {
    grid-template-columns: 1fr;
  }
  
  .about-info-cards__grid--masonry {
    columns: 1;
  }
  
  .about-info-cards__card {
    padding: 2rem;
  }
  
  .about-info-cards__card:nth-child(3) {
    grid-column: span 1;
  }
  
  .about-info-cards__card-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  
  .about-info-cards__card-title {
    font-size: 1.2rem;
  }
  
  .about-info-cards__card-text {
    font-size: 1rem;
    text-align: left;
  }
  
  .about-info-cards__card:nth-child(3) .about-info-cards__card-text {
    text-align: left;
  }
}

@media (max-width: 480px) {
  .about-info-cards__card {
    padding: 1.5rem;
  }
  
  .about-info-cards__card-icon {
    width: 50px;
    height: 50px;
    font-size: 1.2rem;
  }
  
  .about-info-cards__card-title {
    font-size: 1.1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AboutInfoCards.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,uCAAuC,qBAAqB,EAAE;AAC9D,uCAAuC,qBAAqB,EAAE;AAC9D,uCAAuC,qBAAqB,EAAE;AAC9D,uCAAuC,qBAAqB,EAAE;AAC9D,uCAAuC,qBAAqB,EAAE;AAC9D,uCAAuC,qBAAqB,EAAE;;AAE9D;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* AboutInfoCards Component Styles */\n.about-info-cards {\n  padding: 80px 0;\n  background: linear-gradient(135deg, #f8f9ff 0%, #e8f4fd 100%);\n}\n\n.about-info-cards__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n/* Grid Layout */\n.about-info-cards__grid--grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 2rem;\n}\n\n/* Row Layout */\n.about-info-cards__grid--row {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n/* Masonry Layout */\n.about-info-cards__grid--masonry {\n  columns: 2;\n  column-gap: 2rem;\n}\n\n.about-info-cards__grid--masonry .about-info-cards__card {\n  break-inside: avoid;\n  margin-bottom: 2rem;\n}\n\n.about-info-cards__card {\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);\n  border-radius: 16px;\n  padding: 2.5rem;\n  box-shadow: 0 8px 32px rgba(74, 144, 226, 0.1);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(74, 144, 226, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.about-info-cards__card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #4A90E2, #87ceeb, #4A90E2);\n  transform: translateX(-100%);\n  transition: transform 0.3s ease;\n}\n\n.about-info-cards__card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 15px 40px rgba(74, 144, 226, 0.15);\n  border-color: rgba(74, 144, 226, 0.2);\n}\n\n.about-info-cards__card:hover::before {\n  transform: translateX(0);\n}\n\n.about-info-cards__card-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.about-info-cards__card-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  flex-shrink: 0;\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n}\n\n.about-info-cards__card-title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #4A90E2;\n  line-height: 1.3;\n  flex: 1;\n}\n\n.about-info-cards__card-content {\n  line-height: 1.7;\n}\n\n.about-info-cards__card-text {\n  font-size: 1.05rem;\n  color: #555;\n  text-align: justify;\n  margin: 0;\n}\n\n/* Animation for cards */\n.about-info-cards__card {\n  opacity: 0;\n  transform: translateY(30px);\n  animation: fadeInUp 0.6s ease forwards;\n}\n\n.about-info-cards__card:nth-child(1) { animation-delay: 0.1s; }\n.about-info-cards__card:nth-child(2) { animation-delay: 0.2s; }\n.about-info-cards__card:nth-child(3) { animation-delay: 0.3s; }\n.about-info-cards__card:nth-child(4) { animation-delay: 0.4s; }\n.about-info-cards__card:nth-child(5) { animation-delay: 0.5s; }\n.about-info-cards__card:nth-child(6) { animation-delay: 0.6s; }\n\n@keyframes fadeInUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Special styling for third card (longer content) */\n.about-info-cards__card:nth-child(3) {\n  grid-column: span 2;\n}\n\n.about-info-cards__grid--grid .about-info-cards__card:nth-child(3) {\n  grid-column: 1 / -1;\n}\n\n.about-info-cards__card:nth-child(3) .about-info-cards__card-header {\n  justify-content: center;\n  text-align: center;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.about-info-cards__card:nth-child(3) .about-info-cards__card-text {\n  text-align: center;\n  font-size: 1.1rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .about-info-cards {\n    padding: 60px 0;\n  }\n  \n  .about-info-cards__container {\n    padding: 0 1.5rem;\n  }\n  \n  .about-info-cards__grid--grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .about-info-cards__grid--masonry {\n    columns: 1;\n  }\n  \n  .about-info-cards__card {\n    padding: 2rem;\n  }\n  \n  .about-info-cards__card:nth-child(3) {\n    grid-column: span 1;\n  }\n  \n  .about-info-cards__card-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n  \n  .about-info-cards__card-title {\n    font-size: 1.2rem;\n  }\n  \n  .about-info-cards__card-text {\n    font-size: 1rem;\n    text-align: left;\n  }\n  \n  .about-info-cards__card:nth-child(3) .about-info-cards__card-text {\n    text-align: left;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-info-cards__card {\n    padding: 1.5rem;\n  }\n  \n  .about-info-cards__card-icon {\n    width: 50px;\n    height: 50px;\n    font-size: 1.2rem;\n  }\n  \n  .about-info-cards__card-title {\n    font-size: 1.1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
